import React, { useEffect, useState } from 'react';
import { SummarizeIcon } from './SummarizeIcon';
import { useAppSelector } from '../../redux/store';
import Tooltip from '@mui/material/Tooltip';

type Props = {
  onClick: () => void;
};

export const SummaryButton = ({ onClick }: Props) => {
  const summarizeInProgress = useAppSelector((state) => state.app.summarizeInProgress);
  const summaryExists = useAppSelector((state) => state.app.sessionSummaryExists);

  const [activeBullet, setActiveBullet] = useState(0);
  useEffect(() => {
    if (summarizeInProgress) {
      const interval = setInterval(() => {
        setActiveBullet((prev) => (prev < 3 ? prev + 1 : 1));
      }, 300); // Change the active bullet every 300ms
      return () => clearInterval(interval); // Cleanup on stop
    } else {
      setActiveBullet(0); // Set to 0 (no animated bullets) when summarizing stops
    }
  }, [summarizeInProgress]);

  return (
    <Tooltip title="Odpri povzemalnik" placement="top" arrow disableInteractive>
      <button className="summary_button" onClick={onClick}>
        <SummarizeIcon
          activeBullet={activeBullet}
          summarizingInProgress={summarizeInProgress}
          outlineColor={summaryExists && !summarizeInProgress ? '#2B8DFF' : '#CCCCCC'}
          className="icon_button"
        />
      </button>
    </Tooltip>
  );
};
